import { render } from "./RiProdoffering104.vue?vue&type=template&id=8637398a"
import script from "./RiProdoffering104.vue?vue&type=script&lang=js"
export * from "./RiProdoffering104.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering104.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8637398a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8637398a', __exports__)) {
    api.reload('8637398a', __exports__)
  }
  
  module.hot.accept("./RiProdoffering104.vue?vue&type=template&id=8637398a", () => {
    api.rerender('8637398a', render)
  })

}


export default __exports__